import React from 'react';
import { BookPromo } from './components/BookPromo';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <BookPromo data-id="element-1" />
      <SalesPopup data-id="element-2" />
    </div>;
}